import Vue from "vue";

interface Notification {
  id: number;
  message: string;
  status: "danger" | "success" | "warning";
}

const state = Vue.observable({
  notifications: [] as Notification[],
  nextId: 1
});

export const NotificationService = {
  get notifications(): Notification[] {
    return state.notifications;
  },

  show(
    message: string,
    status: "danger" | "success" | "warning" = "danger",
    // Errors persist until the user dismisses them; pass a duration to override.
    duration: number = status === "danger" ? 0 : 5000
  ): void {
    const id = state.nextId++;
    state.notifications.push({ id, message, status });
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }
  },

  remove(id: number): void {
    state.notifications = state.notifications.filter(n => n.id !== id);
  }
};
